//封装axios函数
import request from './index.js'

//菜单
//首页 banner
export function GetCarouselItemByType(data) {
  return request({
    url: 'carouse/getlist/'+data,
    method: 'GET'
  })
}

//根据文章类型 获取文章 get/api/article/getarticlebytype/ article/getarticlebytype/8
export function GetArticleByType(data) {
  return request({
    url: 'article/getarticlebytype/'+data,
    method: 'GET'
  })
}

//文章信息
export function apiGetArticle(data) {
  return request({
    url: 'article/get/'+data,
    method: 'GET'
  })
}

//文章信息 根据Url
export function GetArticleByUrl(data) {
  return request({
    url: 'article/getbyname/'+data,
    method: 'GET'
  })
}

//工程类型
export function apiGetProductType(data) {
  return request({
    url: 'product/get/'+data,
    method: 'GET'
  })
}


//工程信息
export function apiGetProduct(data) {
  return request({
    url: 'product/get/'+data,
    method: 'GET'
  })
}

//根据类型 获取 工程图片
export function apiGetProductByType(data) {
  return request({
    url: 'product/getproductbytype/'+data,
    method: 'GET'
  })
}
//工程图片展示 产品ID 返回图片列表
export function apiGetProductImage(data) {
  return request({
    url: 'productimage/get/'+data,
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js